import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getIn, useFormikContext } from 'formik';
import Grid from '@material-ui/core/Grid';
import { getOptions, getValue } from '@ourbranch/lookups';

import { tooltipHoverTexts } from 'core/helpers/constants';
import { LabelTooltip } from 'core/components/label-tooltip';
import { FormField } from 'core/components/form';
import { AuthContext } from 'core/components/auth';
import Checkbox from 'core/components/checkbox';
import { Label } from 'core/components/label';

const KentuckyAutoLimits = ({ id, disabled, UMBIOptions, UIMBIOptions }) => {
  const { canRejectPIP } = useContext(AuthContext);
  const { setFieldValue, values } = useFormikContext();
  const policyLimitGuestPIPValue = getValue('policyLimitGuestPIP', getIn(values, `${id}.policyLimitGuestPIP`));

  return (
    <>
      <Grid item xs={6}>
        <LabelTooltip
          label="Uninsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUMBI`}
            id={`${id}.policyLimitUMBI`}
            type="select"
            options={UMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      <Grid item xs={6}>
        <LabelTooltip
          label="Underinsured Motorist BI"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.umUimBodilyInjury }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitUIMBI`}
            id={`${id}.policyLimitUIMBI`}
            type="select"
            options={UIMBIOptions}
            optional
            disabled={disabled}
            fast={false}
          />
        </LabelTooltip>
      </Grid>

      <Grid item xs={12}>
        <Grid item xs={12}>
          <Label type="formSubTitle">Personal Injury Protection</Label>
        </Grid>
        <Checkbox
          type="checkbox"
          id="policyLimitNoFaultPIP"
          label="Reject PIP coverage for all drivers"
          tooltipText={canRejectPIP ? null : tooltipHoverTexts.policyLimitNoFaultPIP}
          tooltipLabel={canRejectPIP ? null : 'More Info'}
          disabled={disabled || !canRejectPIP}
          value={getIn(values, `${id}.policyLimitNoFaultPIP`) === 'NONE'}
          onChange={(e) => {
            setFieldValue(`${id}.policyLimitNoFaultPIP`, e.target.checked ? 'NONE' : 'INCLUDED');

            if (e.target.checked) {
              setFieldValue(`${id}.policyLimitPIP`, 'NONE');
              setFieldValue(`${id}.policyLimitGuestPIP`, '10000');
            } else {
              setFieldValue(`${id}.policyLimitGuestPIP`, 'NONE');
            }
          }}
        />
      </Grid>

      <Grid item xs={6}>
        <LabelTooltip
          label="Personal Injury Protection"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.personalInjuryProtection }}
        >
          <FormField
            mode="dark"
            name={`${id}.policyLimitPIP`}
            id={`${id}.policyLimitPIP`}
            type="select"
            options={getOptions('policyLimitPIP', 'KY')}
            optional
            disabled={disabled}
          />
        </LabelTooltip>
      </Grid>
      <Grid item xs={6}>
        <LabelTooltip
          label="Guest PIP"
          tooltip={{ label: 'More Info', onHoverText: tooltipHoverTexts.policyLimitGuestPIP }}
        >
          <FormField
            id={`${id}.policyLimitGuestPIP`}
            name={`${id}.policyLimitGuestPIP`}
            type="value"
            mode="dark"
            value={policyLimitGuestPIPValue}
          />
        </LabelTooltip>
      </Grid>
    </>
  );
};

KentuckyAutoLimits.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  UMBIOptions: PropTypes.array.isRequired,
  UIMBIOptions: PropTypes.array.isRequired
};

KentuckyAutoLimits.defaultProps = {
  disabled: false
};

export default KentuckyAutoLimits;
